import { LayerData, LAYER_TYPE } from './layer.data';
import { TintableLayerData } from './tintable-layer.data';

export class TextLayerData extends TintableLayerData {

  private _font:string;
  private _size:number;
  private _bold:boolean;
  private _italic:boolean;
  private _underline:boolean;
  private _align:string;
  private _leading:number;
  private _text:string;

  static DEFAULT_FONT:string = "Carlito";
  static DEFAULT_SIZE:number = 8;
  static DEFAULT_BOLD:boolean = false;
  static DEFAULT_ITALIC:boolean = false;
  static DEFAULT_UNDERLINE:boolean = false;
  static DEFAULT_ALIGN:string = 'left';

  /**
   * Contructor
   */
  constructor(text: string, font: string, size: number, color: string, bold:boolean, italic:boolean, underline:boolean, align:string, leading:number, x:number = 0, y:number = 0, width:number = NaN, height:number = NaN, rotation:number = 0, alpha:number = 1, locks:any = null, source:string = "CreationLayer", special:string = null) {
    super(color, x, y, width, height, rotation, alpha, locks, source, special);

    this._font = font;
    this._size = size;
    this._bold = bold;
    this._italic = italic;
    this._underline = underline;
    this._align = align;
    this._leading = leading;
    this._text = text;
    this.type = LayerData.TEXT;
  }

  public get font():string {
    return this._font;
  }
  public set font(value:string) {
    this._font = value;
  }

  public get size():number {
    return this._size;
  }
  public set size(value:number) {
    this._size = value;
  }

  public get bold():boolean {
    return this._bold;
  }
  public set bold(value:boolean) {
    this._bold = value;
  }

  public get italic():boolean {
    return this._italic;
  }
  public set italic(value:boolean) {
    this._italic = value;
  }

  public get underline():boolean {
    return this._underline;
  }
  public set underline(value:boolean) {
    this._underline = value;
  }

  public get align():string {
    return this._align;
  }
  public set align(value:string) {
    this._align = value;
  }

  public get leading():number {
    return this._leading;
  }

  public set leading(value:number) {
    this._leading = Math.max(value, -25);
  }

  public get text():string {
    return this._text;
  }

  public set text(value:string) {
    this._text = value;
  }

  /**
   * Clone
   */
  public clone(keepData:boolean = false):LayerData {
    var layerData:TextLayerData = new TextLayerData(this._text, this._font, this._size, this._color, this._bold, this._italic, this._underline, this._align, this._leading);
    layerData.x = this.x;
    layerData.y = this.y;
    layerData.width = this.width;
    layerData.height = this.height;
    layerData.rotation = this.rotation;
    layerData.alpha = this.alpha;
    layerData.locks = keepData ? {position:this._locks.position, rotation:this._locks.rotation, size:this._locks.size, deletion:this._locks.deletion, depth:this._locks.depth, crop:this._locks.crop, tint:this._locks.tint} : null;
    layerData.source = this.source;
    layerData.special = this.special;
    layerData.index = keepData ? this._index : -1;

    return layerData;
  }


  /**
	 * Get data
	 */
  public getData(): any {
    var returnData: any = {
			type: LAYER_TYPE.TEXT,
      design: this.source == LayerData.DESIGN ? 1 : 0,
      text: this._text,
      properties: {
        x: this._x,
        y: this._y,
        width: this._width,
        height: this._height,
        rotation: this._rotation,
        color: this._color,
        font: this._font,
        size: this._size,
        bold: this._bold,
        italic: this._italic,
        underline: this._underline,
        justification: this._align,
        leading: this._leading,
      },
      locking: {
        position: this._locks.position,
        rotation: this._locks.rotation,
        size: this._locks.size,
        delete: this._locks.delete
      }
    };

    return returnData;
  }
}
